import { render } from "./DeleteRolModal.vue?vue&type=template&id=53d205c6"
import script from "./DeleteRolModal.vue?vue&type=script&lang=js"
export * from "./DeleteRolModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__